__turbopack_context__.v({
  "container": "PulseCircle-module__2YBzhW__container",
  "core": "PulseCircle-module__2YBzhW__core",
  "pulse": "PulseCircle-module__2YBzhW__pulse",
  "ring": "PulseCircle-module__2YBzhW__ring",
});
